export const CLOSE_FILTERS = {
  is_closed: { value: true }
};

export const DISABLED_MAKE_INTRO_BUTTON_MESSAGE =
  'This response will unlock when the user claims their Unissu profile';
